import { Vue, debounce } from './config'

if (document.getElementById('news')) {
    new Vue({
        el: '#news',
        components: {
        },
        data: {
            rootId: 0,
            query: '',
            catId: 0,
            cats: [],
            results: [],
            page: 0,
            perPage: 12,
        },
        watch: {
            query: debounce(function (q) {
                this.doSearch()
            }, 500)
        },
        computed: {
            displayPage() {
                return this.page + 1
            },
            pages() {
                return Math.ceil(this.results.length / this.perPage)
            },
            curPage() {
                return this.results.slice(this.page * this.perPage, (this.page * this.perPage) + this.perPage)
            },
        },
        methods: {
            setCat(id) {
                this.catId = id
                this.doSearch()
            },
            doSearch() {
                var vm = this
                vm.doPost('/umbraco/api/news/search', { newsRoot: vm.rootId, query: vm.query, catId: vm.catId }, (data) => {
                    vm.results = data
                })
            },
        },
        mounted() {
            var vm = this
            vm.rootId = vm.$el.dataset.root
            vm.doPost('/umbraco/api/news/getfilters', null, (data) => {
                vm.cats = data
            })
            vm.doSearch()
        }
    })
}